import { zIndices } from '../../../theme/foundations';
export var basePopoverTheme = {
  baseStyle: _ref => {
    var {
      position,
      top,
      left
    } = _ref;
    return {
      trigger: {
        outlineColor: 'transparent',
        _focusVisible: {
          outlineColor: 'focus.focus',
          transition: 'outline-color 0.2s',
          outlineOffset: '2px'
        }
      },
      content: {
        position,
        top: "".concat(top !== null && top !== void 0 ? top : 0, "px"),
        left: "".concat(left !== null && left !== void 0 ? left : 0, "px"),
        backgroundColor: 'neutral.black',
        color: 'neutral.white',
        border: 'none',
        borderRadius: 'l',
        textStyle: 'body4',
        width: 'max-content',
        maxWidth: '296px',
        textAlign: 'start',
        zIndex: 'popover',
        boxShadow: 0,
        paddingX: 's',
        paddingY: 's',
        _focus: {
          boxShadow: 0
        }
      },
      close: {
        position: 'absolute',
        right: 'xs',
        top: 'xs'
      },
      header: {
        display: 'flex',
        alignItems: 'flex-start',
        paddingX: 'none',
        paddingY: 'none',
        marginRight: 'm',
        marginBottom: 'xxs',
        borderBottom: 'none'
      },
      icon: {
        display: 'inline-flex',
        marginY: 'xxxs',
        marginRight: 'xs'
      },
      title: {
        textStyle: 'body3Semi',
        display: 'inline-block',
        maxWidth: '100%',
        paddingX: 'none',
        paddingY: 'none'
      },
      body: {
        paddingX: 'none',
        paddingY: 'none',
        marginRight: 'm',
        wordBreak: 'break-word'
      },
      footer: {
        paddingX: 'none',
        paddingY: 'none',
        marginTop: 's',
        borderTop: 'none',
        display: 'flex',
        justifyContent: 'flex-end'
      },
      footerText: {
        opacity: 0.35
      },
      arrow: {
        fill: 'neutral.black',
        height: '22px',
        width: '22px'
      }
    };
  }
};
export var fadeStyle = {
  position: 'absolute',
  zIndex: zIndices.popover
};
//# sourceMappingURL=BasePopover.theme.js.map